import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: var(--color-neutral-100);
  padding: var(--spacing-large);
`;

export const Container = styled.div`
  background: var(--color-neutral-0);
  border-radius: 12px;
  box-shadow: var(--level-3);
  max-width: 500px;
  width: 100%;
  padding: var(--spacing-x-large);
`;

export const Header = styled.div`
  text-align: center;
  margin-bottom: var(--spacing-large);
`;

export const Description = styled.p`
  color: var(--color-neutral-600);
  font-size: var(--font-size-regular);
  margin-top: var(--spacing-small);
`;

export const Content = styled.div`
  max-height: 400px;
  overflow-y: auto;
`;
